export type Language = 'en' | 'pl';

export const translations = {
  en: {
    appName: 'Elite Coach Cloud',
    subtitle: 'Shared Football Intelligence',
    dashboard: 'Dashboard',
    players: 'Players',
    matches: 'Match Centre',
    matchday: 'Matchday',
    analysis: 'Analysis',
    training: 'Training',
    intelligence: 'Intelligence',
    lineup: 'Lineup',
    harmony: 'Harmony',
    league: 'League',
    news: 'News',
    settings: 'Settings',
    logout: 'Logout',
    season: 'Season',
    headCoach: 'Head Coach',
    squad: 'Squad',
    readiness: 'Readiness',
    chemistry: 'Chemistry',
    fitness: 'Fitness',
    nextMatch: 'Next Match',
    recentActivity: 'Recent Activity',
    connectTitle: 'Connect Elite Coach Cloud',
    publicKey: 'Supabase Publishable / anon key',
    connect: 'Connect',
    loginTitle: 'Coach Login',
    email: 'Email',
    password: 'Password',
    login: 'Log in',
    loading: 'Loading',
    noData: 'No data yet',
    roster: 'Squad Roster',
    registeredPlayers: 'Registered players',
    addPlayer: 'Add Player',
    createPlayer: 'Create Player',
    playerName: 'Player name',
    squadNumber: 'Squad number',
    position: 'Position',
    photoUrlOptional: 'Photo URL (optional)',
    saving: 'Saving',
    removePlayer: 'Remove Player',
    removePlayerConfirm: 'Remove this player from the squad?',
    removePlayerWarning: 'Match contributions and Harmony relationships linked to this player will also be removed.',
    cancel: 'Cancel',
    removing: 'Removing',
    edit: 'Edit',
    editPlayer: 'Edit Player',
    saveChanges: 'Save Changes',
    playerUpdated: 'Player updated successfully.',



    seasonMinutes: 'Season minutes',
    positionOrder: 'Position GK → ST',
    playerSheet: 'Player Sheet',
    overview: 'Overview',
    attributes: 'Attributes',
    mental: 'Mental',
    specialAbilities: 'Special Abilities',
    statistics: 'Statistics',
    apps: 'Apps',
    goals: 'Goals',
    assists: 'Assists',
    minutes: 'Minutes',
    averageRating: 'Average rating',
    form: 'Form',
    morale: 'Morale',
    potential: 'Potential',
    preferredFoot: 'Preferred foot',
    height: 'Height',
    weight: 'Weight',
    coachNotes: 'Coach Notes',
    noCoachNotes: 'No coach notes',
    close: 'Close',
    teamSelection: 'Team',
    liveData: 'Live data',
    wins: 'Wins',
    matchesPlayed: 'Matches',
    averageForm: 'Average form',
    squadAvailability: 'Squad availability',
    matchCentreSubtitle: 'Create, review and control every matchday.',
    createMatchday: 'Create Matchday',
    date: 'Date',
    opponent: 'Opponent',
    competition: 'Competition',
    saveMatchday: 'Save Matchday',
    requiredFields: 'Date and opponent are required.',
    matchCreated: 'Matchday created successfully.',
    completed: 'Completed',
    upcoming: 'Upcoming',
    noMatches: 'No matches created yet.',
    lineupSubtitle: 'Build and save professional matchday formations.',
    lineupName: 'Lineup name',
    formation: 'Formation',
    saveLineup: 'Save Lineup',
    lineupSaved: 'Lineup saved successfully.',
    savedLineups: 'Saved Lineups',
    noSavedLineups: 'No saved lineups yet.',
    harmonySubtitle: 'Understand chemistry, partnerships and squad dynamics.',
    strongLink: 'Strong link',
    mediumLink: 'Developing link',
    weakLink: 'Weak link',
    unknownPlayer: 'Unknown player',
    noRelationships: 'No player relationships recorded yet.',
    leagueIntelligence: 'League Intelligence',
    leagueSubtitle: 'Performance, form, scoring and fixture intelligence.',
    localLeagueScope: 'Table is calculated from league matches currently stored in Elite Coach Cloud.',
    projectedPosition: 'Data position',
    points: 'Points',
    played: 'Played',
    winRate: 'Win rate',
    goalDifference: 'Goal difference',
    performanceTable: 'Performance table',
    standings: 'Standings',
    completedLeagueMatches: 'Recorded league matches',
    club: 'Club',
    playedShort: 'P',
    wonShort: 'W',
    drawnShort: 'D',
    lostShort: 'L',
    goalDifferenceShort: 'GD',
    goalsForShort: 'GF',
    goalsAgainstShort: 'GA',
    officialGdsfcData: 'Official GDSFC data',
    gdsfcAutoSync: 'GDSFC Auto Sync',
    lastSynced: 'Last synced',
    awaitingCurrentSeasonFeed: 'Waiting for GDSFC to publish the current-season live feed.',
    officialGdsfcScorer: 'Official GDSFC top-scorer table',
    latestOfficialResults: 'Latest Official Results',
    autoSynced: 'Auto-synced',


    pointsShort: 'PTS',
    noLeagueResults: 'No completed Premiership matches are stored yet.',
    squadProduction: 'Squad production',
    topScorers: 'Top scorers',
    schedule: 'Schedule',
    upcomingFixtures: 'Upcoming fixtures',
    noUpcomingFixtures: 'No upcoming fixtures stored.',
    unknownOpponent: 'Unknown opponent',
    systemAdministration: 'System Administration',
    preMatchSystemCheck: 'Pre-Match System Check',
    preMatchSystemCheckDescription: 'Critical readiness checks before the application is used on matchday.',
    runSystemCheck: 'Run system check',
    deviceMatchdayDiagnostics: 'Device & Matchday Diagnostics',
    deviceMatchdayDiagnosticsDescription: 'Run a quick operational check on this device before matchday.',
    runDiagnostics: 'Run diagnostics',
    runningDiagnostics: 'Running diagnostics…',
    localStorageDiagnostic: 'Local storage',
    networkDiagnostic: 'Network',
    pwaDiagnostic: 'App mode',
    rosterDiagnostic: 'Roster readiness',
    lineupDiagnostic: 'Lineup protection',
    matchdayDiagnostic: 'Matchday data',
    leagueDiagnostic: 'League identity',
    supabaseDiagnostic: 'Supabase cloud',
    storageUnavailable: 'Device storage unavailable',
    connectionNotConfigured: 'Cloud connection not configured',
    gdsfcSeasonGuardPending: 'Infrastructure ready · current-season feed pending',

    criticalChecksReady: 'critical checks ready',
    waiting: 'Waiting',

    settingsSubtitle: 'Control teams, language, cloud connection and data continuity.',
    operational: 'Operational',
    attentionRequired: 'Attention required',
    language: 'Language',
    languageDescription: 'Choose the interface language.',
    activeTeam: 'Active team',
    activeTeamDescription: 'Select the team currently shown in the application.',
    role: 'Role',
    administrator: 'Administrator',
    headCoach: 'Head Coach',
    player: 'Player',
    staffAccess: 'Staff & Access',
    accessControl: 'Access Control',
    accessControlDescription: 'Current signed-in account, membership role and operational permissions.',
    signedInAccount: 'Signed-in account',
    membershipRole: 'Membership role',
    accessScope: 'Access scope',
    fullAdministrativeAccess: 'Full coaching + administration',
    coachingAccess: 'Full coaching operations',
    accessAdministration: 'Access administration',
    administratorRequired: 'Administrator access required',
    administratorOnly: 'Administrator only',
    staffAccessReadOnlyDescription: 'Staff roles are visible, but account and invitation administration is restricted.',
    staffAccessLockedDescription: 'Only the Administrator can manage coach access and invitations.',
    accessAdministrationLocked: 'Connection and access administration is locked for Head Coach accounts.',

    invitesRemainPendingUntilAccountsLinked: 'Pending until coach accounts are created and linked',
    staffAccessDescription: 'Club leadership roles and prepared coach access.',
    active: 'Active',
    invitationPending: 'Invitation pending',
    preparedInvitations: 'prepared invitations',
    invitationEmailNeeded: 'Dominik Lichon and Marcin Śliwa are ready for Head Coach access. Email addresses are required only when the invitations are sent.',

    cloudConnection: 'Cloud connection',
    cloudConnectionDescription: 'Supabase connection currently used by this device.',
    project: 'Project',
    keyFingerprint: 'Key fingerprint',
    status: 'Status',
    connected: 'Connected',
    dataInventory: 'Data inventory',
    dataInventoryDescription: 'Live records loaded for the active team.',
    relationships: 'Relationships',
    device: 'Device',
    deviceDescription: 'Current browser and installation state.',
    platform: 'Platform',
    onlineStatus: 'Network',
    online: 'Online',
    offline: 'Offline',
    appMode: 'App mode',
    browser: 'Browser',
    unknown: 'Unknown',
    maintenance: 'Maintenance',
    maintenanceDescription: 'Refresh cloud data or export a local safety copy.',
    refreshData: 'Refresh data',
    exportBackup: 'Export backup',
    matchdayEmergencyBackup: 'Matchday Emergency Backup',
    matchdayEmergencyBackupDescription: 'Download a complete safety snapshot before matchday, including cloud records and protected local match data.',
    includesCloudAndLocalData: 'Includes cloud + local matchday data',
    lastBackup: 'Last snapshot',
    never: 'Never',
    createMatchdaySnapshot: 'Create emergency snapshot',
    emergencySnapshotCreated: 'Emergency matchday snapshot created',

    refreshing: 'Refreshing cloud data…',
    refreshComplete: 'Cloud data refreshed.',
    backupCreated: 'Backup file created.',
    resetConnection: 'Reset cloud connection',
    resetConnectionDescription: 'Remove the public Supabase key from this device.',
    prepareReset: 'Prepare reset',
    resetWarning: 'You will need to paste the public anon key again. No cloud data will be deleted.',
    confirmReset: 'Confirm reset',
    cancel: 'Cancel',
    clubIdentity: 'Club Identity',
    premiershipClubs: 'Premiership clubs',
    activeClubs: 'active clubs',
    selectedClub: 'Selected club',
    clubKey: 'Club key',
    databaseStatus: 'Database status',
    databaseLinked: 'Linked to Supabase',
    databasePending: 'Bundled fallback active',
    aliases: 'Recognised names',
    leagueIdentity: 'League identity',
    clubsLinked: 'clubs linked',
    professionalMatchCentre: 'Professional Match Centre',
    professionalMatchSubtitle: 'Live match control, tactical information and coaching intelligence.',
    matchOperations: 'Match Operations',
    setup: 'Setup',
    liveMatch: 'Live Match',
    matchdaySafety: 'Matchday Safety',
    keepScreenAwake: 'Keep screen awake',
    allowScreenSleep: 'Allow screen sleep',
    screenAwakeActive: 'Screen awake active',
    screenAwakeOff: 'Screen wake lock off',
    screenAwakeUnavailable: 'Screen wake lock is not supported by this browser',
    screenAwakeFailed: 'Could not activate screen wake lock',
    undoLastEvent: 'Undo last event',
    nothingToUndo: 'Nothing to undo',
    lastEventRemoved: 'Removed',

    goToLiveMatch: 'Go Live',

    history: 'History',
    selectMatch: 'Select match',
    loadLatestLineup: 'Load latest lineup',
    venue: 'Venue',
    referee: 'Referee',
    weather: 'Weather',
    attendance: 'Attendance',
    notStarted: 'Not Started',
    firstHalf: 'First Half',
    halfTime: 'Half Time',
    secondHalf: 'Second Half',
    fullTime: 'Full Time',
    liveActions: 'Live actions',
    matchEvents: 'Match events',
    goal: 'Goal',
    assist: 'Assist',
    yellowCard: 'Yellow card',
    redCard: 'Red card',
    substitution: 'Substitution',
    injury: 'Injury',
    period: 'Period',
    coachNote: 'Coach note',
    chronology: 'Chronology',
    timeline: 'Timeline',
    events: 'events',
    noEventsYet: 'No match events recorded yet.',
    performanceData: 'Performance data',
    matchStatistics: 'Match statistics',
    possession: 'Possession',
    shots: 'Shots',
    shotsOnTarget: 'Shots on target',
    corners: 'Corners',
    fouls: 'Fouls',
    offsides: 'Offsides',
    passes: 'Passes',
    passAccuracy: 'Pass accuracy',
    onPitch: 'On pitch',
    coachPanel: 'Coach panel',
    coachNotes: 'Coach notes',
    coachNotesPlaceholder: 'Tactical observations, opposition weaknesses, next adjustments…',
    saveAndSync: 'Save & Sync',
    saving: 'Saving…',
    savedOnDevice: 'Saved on this device.',
    savedOnDeviceMigrationNeeded: 'Saved locally. Run the Sprint 6 Supabase migration to enable coach-to-coach sync.',
    cloudSynced: 'Cloud sync complete.',
    cloudSyncedStatus: 'Cloud synced',
    localChangesPending: 'Local changes pending',
    offlineProtected: 'Offline · protected locally',
    offlineChangesProtected: 'Offline — changes are protected on this device',
    localChangesProtected: 'local changes remain protected',
    lastCloudSave: 'Last cloud save',
    noCloudSaveYet: 'No successful cloud save yet',
    syncPendingChanges: 'Sync pending changes',
    cloudLive: 'Cloud sync active',
    deviceFallback: 'Device fallback',
    checkingCloud: 'Checking cloud',
    addEvent: 'Add event',
    player: 'Player',
    playerOut: 'Player out',
    playerIn: 'Player in',
    detail: 'Detail',
    playerPerformance: 'Player Performance',
    liveRatings: 'Live ratings',
    bench: 'Bench',
    confirmSubstitution: 'Confirm substitution',
    livePlayerCard: 'Live player card',
    startingXI: 'Starting XI',
    playerNotesPlaceholder: 'Performance notes, tactical instructions, individual observations…',
    round: 'Round',
    coachOverride: 'Coach-created matchday',
    officialGdsfcFixture: 'Official GDSFC fixture',
    premiershipSchedule: 'Premiership schedule',
    leagueMatches: 'league matches',
    setKickoffBeforeSaving: 'Official fixture date loaded. Please set the confirmed kick-off time before saving.',
    kickoffRefereeSourceNote: 'GDSFC currently publishes the fixture date/opponent here. Kick-off, venue and referee remain TBA until officially confirmed or entered by a coach.',
    backToDashboard: 'Back to Dashboard',
    matchdayGraphic: 'Matchday Graphic',
    lineupGraphic: 'Lineup Graphic',
    fullTimeGraphic: 'Full-Time Graphic',
    fullTime: 'Full Time',
    scorers: 'Scorers',
    assists: 'Assists',
    playerOfTheMatch: 'Player of the Match',
    onePlayerPerLine: 'One player per line',
    toBeSelected: 'To be selected',

    matchdayGraphicSubtitle: 'Generate a premium share graphic from the announced lineup and match data.',
    socialFormat: 'Social format',
    currentLineup: 'Current lineup',
    selectedPlayers: 'Selected players',
    lineupNeedsEleven: 'For an official Starting XI graphic, select exactly 11 players.',
    shareGraphic: 'Share graphic',
    exportPng: 'Export PNG',
    generatingGraphic: 'Generating matchday graphic…',
    graphicReady: 'PNG ready.',
    sharedSuccessfully: 'Share sheet opened successfully.',
    noMatchAvailable: 'No upcoming match is available for the graphic.',
    substitutes: 'Substitutes',
    coachingStaff: 'Coaching staff',
    headCoach: 'Head Coach',
    assistantCoach: 'Assistant Coach',
    coach: 'Coach',
    addCoach: 'Add coach',
    coachRole: 'Role',
    coachName: 'Coach name',
    teamPhoto: 'Team photo',
    uploadTeamPhoto: 'Upload current team photo',
    teamPhotoHint: 'Photo is optimized on-device and included in the exported graphic.',
    noBenchCandidates: 'No additional squad players are available.',
    optimizingPhoto: 'Optimizing photo…',
    photoReady: 'Photo ready for the Matchday graphic.',
    photoUploadFailed: 'The photo could not be processed.',
    photoStorageWarning: 'The image is too large for local device storage. Export still remains available for this session.',
    tacticalBoardSubtitle: 'Build, move and announce the matchday XI from one command surface.',
    tacticalPresets: 'Tactical presets',
    gamePlan: 'Game plan',
    balancedPreset: 'Balanced control',
    balancedPresetDesc: 'Width, possession and stable rest defence.',
    highPressPreset: 'High press',
    highPressPresetDesc: 'Aggressive first line with a compact double pivot.',
    lowBlockPreset: 'Compact block',
    lowBlockPresetDesc: 'Two banks of four with direct counter options.',
    directPreset: 'Direct overload',
    directPresetDesc: 'Three centre-backs, wing-backs and two support attackers.',
    presetApplied: 'Tactical preset applied.',
    resetBoard: 'Reset board',
    availablePlayers: 'Available players',
    touchPlacementInstruction: 'Touch: select a player, then tap a pitch position. Desktop: drag and drop.',
    leadership: 'Leadership',
    captain: 'Captain',
    viceCaptain: 'Vice Captain',
    announceLineup: 'Announce lineup',
    lineupAnnouncedStatus: 'Lineup announced',
    lineupAnnounced: 'Starting XI marked as announced.',
    lineupReturnedToDraft: 'Lineup returned to draft.',
    announced: 'Announced',
    draft: 'Draft',
    savedLineupLoaded: 'Saved lineup loaded.',
    matchdayCommandCentre: 'Matchday Command Centre',
    matchdayReadiness: 'Matchday Readiness',
    matchdayQuickAccess: 'Matchday quick access',
    sundayGoLive: 'Sunday Go-Live',
    matchdayControl: 'Matchday Control',
    localDraftRecovered: 'Local lineup draft recovered',
    lineupSavedCloudAndDevice: 'Lineup saved to cloud and protected locally',
    localDraftProtected: 'Local draft is protected',
    localBackupActive: 'Local backup active',
    localBackupPreparing: 'Preparing local backup',
    localBackup: 'Local backup',

    matchSelected: 'Match selected',
    lineupAttached: 'Lineup attached',

    matchdayCommandSubtitle: 'Link the announced XI to a fixture and control the full matchday from one place.',
    attachLineup: 'Attach lineup',
    matchdayCommandSaved: 'Matchday command state saved.',
    matchdayStatus: 'Matchday status',
    planning: 'Planning',
    live: 'Live',
    complete: 'Complete',
    attachedLineup: 'Attached lineup',
    openTacticalBoard: 'Open tactical setup and make changes.',
    openLiveMatch: 'Open live clock, events and player ratings.',
    mediaStudioBelow: 'Create and share the official matchday artwork below.',
    performanceReview: 'Performance Review',
    performanceReviewSubtitle: 'Review match output, identify player development needs and build the future training queue.',
    matchRatings: 'Match ratings',
    developmentProfile: 'Development profile',
    started: 'Started',
    technical: 'Technical',
    tactical: 'Tactical',
    physical: 'Physical',
    developmentNeed: 'Development need',
    flagWeakness: 'Flag weakness',
    weakness: 'Weakness',
    priority: 'Priority',
    developmentNotePlaceholder: 'What happened in the match? What should improve?',
    saveDevelopmentNeed: 'Save development need',
    developmentSignalSaved: 'Development need saved.',
    developmentPriorities: 'Development priorities',
    trainingQueue: 'Future training queue',
    noDevelopmentNeeds: 'No development needs have been flagged for this player.',
    trainingModulePreview: 'These priorities will feed the dedicated Training module with individual and team exercises.',
    noCompletedMatches: 'No completed matches are available for review yet.',
    trainingSubtitle: 'Turn individual and team weaknesses into practical football training actions.',
    individualTraining: 'Individual',
    teamTraining: 'Team',
    selectPlayer: 'Select player',
    playerDevelopment: 'Player development',
    trainingPlayerSheet: 'Training Player Sheet',
    manualTrainingTarget: 'Manual training target',
    trainingMethod: 'Training method',
    organisation: 'Organisation',
    individualBlock: 'Individual block',
    teamApplication: 'Team application',
    coachingPoints: 'Coaching points',
    progression: 'Progression',
    workRest: 'Work / rest',
    externalMethodReference: 'Open external method / reference',
    teamWeakness: 'Team weakness',
    teamSession: 'Team session',
    setPieces: 'Set pieces',
    objective: 'Objective',
    sessionStructure: 'Session structure',
    linkFirstTrainingNote: 'Video, photo and board material stays external when possible to keep the app lightweight. Links open the original coaching reference.',
    coachIntelligence: 'Coach Intelligence',
    coachIntelligenceSubtitle: 'Convert development signals and match timing into practical coaching priorities.',
    priorityNeeds: 'Priority needs',
    teamRecommendation: 'Team recommendation',
    smartTrainingCalendar: 'Smart Training Calendar',
    trainingWeek: 'Training week',
    smartPlannerNote: 'The planner adapts the week to proximity to the next fixture and keeps the hardest football load away from MD-1.',
    intelligenceMethod: 'How recommendations are built',
    intelligenceMethodNote: 'Recommendations combine coach-flagged development needs, player role and match timing. They are coaching support, not a substitute for medical or performance staff judgement.',
    sessionLibrary: 'Session Library',
    sessionLibrarySubtitle: 'Save, favourite and reuse training sessions without filling the app with heavy media.',
    addSession: 'Add session',
    searchSessions: 'Search sessions',
    sessionTitle: 'Session title',
    optionalLink: 'Optional external link',
    saveSession: 'Save session',
    favourite: 'Favourite',
    openReference: 'Open reference',
    internalSession: 'Internal session',
    developmentProgress: 'Development Progress',
    developmentProgressSubtitle: 'Track the same development target across the season instead of relying on one-off observations.',
    currentFocus: 'Current focus',
    progress: 'Progress',
    noProgressCheckpoints: 'No development checkpoints recorded yet.',
    developmentScore: 'Development score',
    progressNotePlaceholder: 'What improved? What still needs work?',
    saveCheckpoint: 'Save checkpoint',








  },
  pl: {
    appName: 'Elite Coach Cloud',
    subtitle: 'Wspólna inteligencja piłkarska',
    dashboard: 'Panel',
    players: 'Zawodnicy',
    matches: 'Centrum meczowe',
    matchday: 'Dzień meczowy',
    analysis: 'Analiza',
    training: 'Trening',
    intelligence: 'Inteligencja',
    lineup: 'Ustawienie',
    harmony: 'Harmonia',
    league: 'Liga',
    news: 'News',
    settings: 'Ustawienia',
    logout: 'Wyloguj',
    season: 'Sezon',
    headCoach: 'Pierwszy trener',
    squad: 'Kadra',
    readiness: 'Gotowość',
    chemistry: 'Chemia',
    fitness: 'Sprawność',
    nextMatch: 'Następny mecz',
    recentActivity: 'Ostatnia aktywność',
    connectTitle: 'Połącz Elite Coach Cloud',
    publicKey: 'Klucz Supabase Publishable / anon',
    connect: 'Połącz',
    loginTitle: 'Logowanie trenera',
    email: 'E-mail',
    password: 'Hasło',
    login: 'Zaloguj',
    loading: 'Ładowanie',
    noData: 'Brak danych',
    roster: 'Kadra zespołu',
    registeredPlayers: 'Zarejestrowani zawodnicy',
    addPlayer: 'Dodaj zawodnika',
    createPlayer: 'Utwórz zawodnika',
    playerName: 'Imię i nazwisko',
    squadNumber: 'Numer w kadrze',
    position: 'Pozycja',
    photoUrlOptional: 'Adres URL zdjęcia (opcjonalnie)',
    saving: 'Zapisywanie',
    removePlayer: 'Usuń zawodnika',
    removePlayerConfirm: 'Usunąć tego zawodnika z kadry?',
    removePlayerWarning: 'Powiązane występy meczowe i relacje Harmony tego zawodnika również zostaną usunięte.',
    cancel: 'Anuluj',
    removing: 'Usuwanie',
    edit: 'Edytuj',
    editPlayer: 'Edytuj zawodnika',
    saveChanges: 'Zapisz zmiany',
    playerUpdated: 'Dane zawodnika zostały zaktualizowane.',



    seasonMinutes: 'Minuty w sezonie',
    positionOrder: 'Pozycje BR → N',
    playerSheet: 'Karta zawodnika',
    overview: 'Przegląd',
    attributes: 'Atrybuty',
    mental: 'Mentalność',
    specialAbilities: 'Umiejętności specjalne',
    statistics: 'Statystyki',
    apps: 'Występy',
    goals: 'Gole',
    assists: 'Asysty',
    minutes: 'Minuty',
    averageRating: 'Średnia ocena',
    form: 'Forma',
    morale: 'Morale',
    potential: 'Potencjał',
    preferredFoot: 'Preferowana noga',
    height: 'Wzrost',
    weight: 'Waga',
    coachNotes: 'Notatki trenera',
    noCoachNotes: 'Brak notatek trenera',
    close: 'Zamknij',
    teamSelection: 'Drużyna',
    liveData: 'Dane na żywo',
    wins: 'Zwycięstwa',
    matchesPlayed: 'Mecze',
    averageForm: 'Średnia forma',
    squadAvailability: 'Dostępność kadry',
    matchCentreSubtitle: 'Twórz, przeglądaj i kontroluj każdy dzień meczowy.',
    createMatchday: 'Utwórz mecz',
    date: 'Data',
    opponent: 'Przeciwnik',
    competition: 'Rozgrywki',
    saveMatchday: 'Zapisz mecz',
    requiredFields: 'Data i przeciwnik są wymagane.',
    matchCreated: 'Mecz został utworzony.',
    completed: 'Zakończony',
    upcoming: 'Nadchodzący',
    noMatches: 'Nie utworzono jeszcze żadnych meczów.',
    lineupSubtitle: 'Buduj i zapisuj profesjonalne ustawienia meczowe.',
    lineupName: 'Nazwa ustawienia',
    formation: 'Formacja',
    saveLineup: 'Zapisz ustawienie',
    lineupSaved: 'Ustawienie zostało zapisane.',
    savedLineups: 'Zapisane ustawienia',
    noSavedLineups: 'Brak zapisanych ustawień.',
    harmonySubtitle: 'Analizuj chemię, partnerstwa i dynamikę zespołu.',
    strongLink: 'Silne połączenie',
    mediumLink: 'Rozwijające się połączenie',
    weakLink: 'Słabe połączenie',
    unknownPlayer: 'Nieznany zawodnik',
    noRelationships: 'Nie zapisano jeszcze relacji między zawodnikami.',
    leagueIntelligence: 'Inteligencja ligowa',
    leagueSubtitle: 'Analiza wyników, formy, bramek i terminarza.',
    localLeagueScope: 'Tabela jest obliczana z meczów ligowych zapisanych obecnie w Elite Coach Cloud.',
    projectedPosition: 'Pozycja danych',
    points: 'Punkty',
    played: 'Rozegrane',
    winRate: 'Procent zwycięstw',
    goalDifference: 'Bilans bramek',
    performanceTable: 'Tabela wyników',
    standings: 'Klasyfikacja',
    completedLeagueMatches: 'Zapisane mecze ligowe',
    club: 'Klub',
    playedShort: 'M',
    wonShort: 'Z',
    drawnShort: 'R',
    lostShort: 'P',
    goalDifferenceShort: 'BR',
    goalsForShort: 'BZ',
    goalsAgainstShort: 'BS',
    officialGdsfcData: 'Oficjalne dane GDSFC',
    gdsfcAutoSync: 'Automatyczna synchronizacja GDSFC',
    lastSynced: 'Ostatnia synchronizacja',
    awaitingCurrentSeasonFeed: 'Oczekiwanie na publikację danych bieżącego sezonu przez GDSFC.',
    officialGdsfcScorer: 'Oficjalna tabela strzelców GDSFC',
    latestOfficialResults: 'Najnowsze oficjalne wyniki',
    autoSynced: 'Synchronizacja automatyczna',


    pointsShort: 'PKT',
    noLeagueResults: 'Brak zapisanych zakończonych meczów Premiership.',
    squadProduction: 'Dorobek zespołu',
    topScorers: 'Najlepsi strzelcy',
    schedule: 'Terminarz',
    upcomingFixtures: 'Nadchodzące mecze',
    noUpcomingFixtures: 'Brak zapisanych nadchodzących meczów.',
    unknownOpponent: 'Nieznany przeciwnik',
    systemAdministration: 'Administracja systemem',
    preMatchSystemCheck: 'Kontrola systemu przed meczem',
    preMatchSystemCheckDescription: 'Krytyczne kontrole gotowości przed użyciem aplikacji w dniu meczu.',
    runSystemCheck: 'Uruchom kontrolę systemu',
    deviceMatchdayDiagnostics: 'Diagnostyka urządzenia i dnia meczowego',
    deviceMatchdayDiagnosticsDescription: 'Uruchom szybki test operacyjny tego urządzenia przed meczem.',
    runDiagnostics: 'Uruchom diagnostykę',
    runningDiagnostics: 'Trwa diagnostyka…',
    localStorageDiagnostic: 'Pamięć lokalna',
    networkDiagnostic: 'Sieć',
    pwaDiagnostic: 'Tryb aplikacji',
    rosterDiagnostic: 'Gotowość kadry',
    lineupDiagnostic: 'Ochrona składu',
    matchdayDiagnostic: 'Dane meczowe',
    leagueDiagnostic: 'Identyfikacja ligi',
    supabaseDiagnostic: 'Chmura Supabase',
    storageUnavailable: 'Pamięć urządzenia niedostępna',
    connectionNotConfigured: 'Połączenie z chmurą nie jest skonfigurowane',
    gdsfcSeasonGuardPending: 'Infrastruktura gotowa · oczekiwanie na dane bieżącego sezonu',

    criticalChecksReady: 'krytycznych kontroli gotowych',
    waiting: 'Oczekiwanie',

    settingsSubtitle: 'Zarządzaj drużynami, językiem, chmurą i ciągłością danych.',
    operational: 'System sprawny',
    attentionRequired: 'Wymagana uwaga',
    language: 'Język',
    languageDescription: 'Wybierz język interfejsu.',
    activeTeam: 'Aktywna drużyna',
    activeTeamDescription: 'Wybierz drużynę wyświetlaną w aplikacji.',
    role: 'Rola',
    administrator: 'Administrator',
    headCoach: 'Główny trener',
    player: 'Zawodnik',
    staffAccess: 'Sztab i dostęp',
    accessControl: 'Kontrola dostępu',
    accessControlDescription: 'Aktualne konto, rola członkostwa i uprawnienia operacyjne.',
    signedInAccount: 'Zalogowane konto',
    membershipRole: 'Rola członkostwa',
    accessScope: 'Zakres dostępu',
    fullAdministrativeAccess: 'Pełny dostęp trenerski i administracyjny',
    coachingAccess: 'Pełne funkcje trenerskie',
    accessAdministration: 'Administracja dostępem',
    administratorRequired: 'Wymagany dostęp administratora',
    administratorOnly: 'Tylko administrator',
    staffAccessReadOnlyDescription: 'Role sztabu są widoczne, ale zarządzanie kontami i zaproszeniami jest ograniczone.',
    staffAccessLockedDescription: 'Tylko Administrator może zarządzać dostępem trenerów i zaproszeniami.',
    accessAdministrationLocked: 'Administracja połączeniem i dostępem jest zablokowana dla kont Head Coach.',

    invitesRemainPendingUntilAccountsLinked: 'Oczekuje do utworzenia i powiązania kont trenerów',
    staffAccessDescription: 'Role kierownicze klubu i przygotowany dostęp trenerów.',
    active: 'Aktywny',
    invitationPending: 'Zaproszenie oczekuje',
    preparedInvitations: 'przygotowane zaproszenia',
    invitationEmailNeeded: 'Dominik Lichon i Marcin Śliwa są przygotowani do dostępu jako główni trenerzy. Adresy e-mail będą potrzebne dopiero przy wysyłaniu zaproszeń.',

    cloudConnection: 'Połączenie z chmurą',
    cloudConnectionDescription: 'Połączenie Supabase używane obecnie przez urządzenie.',
    project: 'Projekt',
    keyFingerprint: 'Odcisk klucza',
    status: 'Status',
    connected: 'Połączono',
    dataInventory: 'Stan danych',
    dataInventoryDescription: 'Rekordy aktywnej drużyny pobrane z chmury.',
    relationships: 'Relacje',
    device: 'Urządzenie',
    deviceDescription: 'Bieżący stan przeglądarki i instalacji.',
    platform: 'Platforma',
    onlineStatus: 'Sieć',
    online: 'Online',
    offline: 'Offline',
    appMode: 'Tryb aplikacji',
    browser: 'Przeglądarka',
    unknown: 'Nieznane',
    maintenance: 'Konserwacja',
    maintenanceDescription: 'Odśwież dane lub wyeksportuj lokalną kopię bezpieczeństwa.',
    refreshData: 'Odśwież dane',
    exportBackup: 'Eksportuj kopię',
    matchdayEmergencyBackup: 'Awaryjna kopia dnia meczowego',
    matchdayEmergencyBackupDescription: 'Pobierz pełną kopię bezpieczeństwa przed meczem, obejmującą dane z chmury oraz chronione lokalne dane meczowe.',
    includesCloudAndLocalData: 'Zawiera dane z chmury i lokalne dane meczowe',
    lastBackup: 'Ostatnia kopia',
    never: 'Nigdy',
    createMatchdaySnapshot: 'Utwórz kopię awaryjną',
    emergencySnapshotCreated: 'Utworzono awaryjną kopię dnia meczowego',

    refreshing: 'Odświeżanie danych chmurowych…',
    refreshComplete: 'Dane chmurowe zostały odświeżone.',
    backupCreated: 'Plik kopii został utworzony.',
    resetConnection: 'Resetuj połączenie z chmurą',
    resetConnectionDescription: 'Usuń publiczny klucz Supabase z tego urządzenia.',
    prepareReset: 'Przygotuj reset',
    resetWarning: 'Publiczny klucz anon trzeba będzie wkleić ponownie. Dane w chmurze nie zostaną usunięte.',
    confirmReset: 'Potwierdź reset',
    cancel: 'Anuluj',
    clubIdentity: 'Tożsamość klubów',
    premiershipClubs: 'Kluby Premiership',
    activeClubs: 'aktywnych klubów',
    selectedClub: 'Wybrany klub',
    clubKey: 'Klucz klubu',
    databaseStatus: 'Status bazy danych',
    databaseLinked: 'Połączono z Supabase',
    databasePending: 'Aktywny lokalny wariant zapasowy',
    aliases: 'Rozpoznawane nazwy',
    leagueIdentity: 'Tożsamość ligi',
    clubsLinked: 'połączonych klubów',
    professionalMatchCentre: 'Profesjonalne centrum meczowe',
    professionalMatchSubtitle: 'Kontrola meczu na żywo, informacje taktyczne i analiza trenerska.',
    matchOperations: 'Operacje meczowe',
    setup: 'Przygotowanie',
    liveMatch: 'Mecz na żywo',
    matchdaySafety: 'Bezpieczeństwo dnia meczowego',
    keepScreenAwake: 'Nie wygaszaj ekranu',
    allowScreenSleep: 'Zezwól na wygaszenie ekranu',
    screenAwakeActive: 'Ekran pozostaje aktywny',
    screenAwakeOff: 'Blokada wygaszania wyłączona',
    screenAwakeUnavailable: 'Ta przeglądarka nie obsługuje blokady wygaszania ekranu',
    screenAwakeFailed: 'Nie udało się włączyć blokady wygaszania ekranu',
    undoLastEvent: 'Cofnij ostatnie zdarzenie',
    nothingToUndo: 'Brak zdarzeń do cofnięcia',
    lastEventRemoved: 'Usunięto',

    goToLiveMatch: 'Przejdź do meczu na żywo',

    history: 'Historia',
    selectMatch: 'Wybierz mecz',
    loadLatestLineup: 'Wczytaj ostatni skład',
    venue: 'Miejsce',
    referee: 'Sędzia',
    weather: 'Pogoda',
    attendance: 'Frekwencja',
    notStarted: 'Nierozpoczęty',
    firstHalf: 'Pierwsza połowa',
    halfTime: 'Przerwa',
    secondHalf: 'Druga połowa',
    fullTime: 'Koniec meczu',
    liveActions: 'Akcje na żywo',
    matchEvents: 'Wydarzenia meczowe',
    goal: 'Gol',
    assist: 'Asysta',
    yellowCard: 'Żółta kartka',
    redCard: 'Czerwona kartka',
    substitution: 'Zmiana',
    injury: 'Kontuzja',
    period: 'Faza meczu',
    coachNote: 'Notatka trenera',
    chronology: 'Chronologia',
    timeline: 'Oś wydarzeń',
    events: 'wydarzeń',
    noEventsYet: 'Nie zapisano jeszcze wydarzeń meczowych.',
    performanceData: 'Dane meczowe',
    matchStatistics: 'Statystyki meczu',
    possession: 'Posiadanie piłki',
    shots: 'Strzały',
    shotsOnTarget: 'Strzały celne',
    corners: 'Rzuty rożne',
    fouls: 'Faule',
    offsides: 'Spalone',
    passes: 'Podania',
    passAccuracy: 'Celność podań',
    onPitch: 'Na boisku',
    coachPanel: 'Panel trenera',
    coachNotes: 'Notatki trenera',
    coachNotesPlaceholder: 'Obserwacje taktyczne, słabości rywala, kolejne korekty…',
    saveAndSync: 'Zapisz i synchronizuj',
    saving: 'Zapisywanie…',
    savedOnDevice: 'Zapisano na tym urządzeniu.',
    savedOnDeviceMigrationNeeded: 'Zapisano lokalnie. Uruchom migrację Supabase Sprint 6, aby włączyć synchronizację trenerów.',
    cloudSynced: 'Synchronizacja z chmurą zakończona.',
    cloudSyncedStatus: 'Zsynchronizowano z chmurą',
    localChangesPending: 'Lokalne zmiany oczekują na synchronizację',
    offlineProtected: 'Offline · dane chronione lokalnie',
    offlineChangesProtected: 'Offline — zmiany są chronione na tym urządzeniu',
    localChangesProtected: 'lokalne zmiany pozostają zabezpieczone',
    lastCloudSave: 'Ostatni zapis w chmurze',
    noCloudSaveYet: 'Brak udanego zapisu w chmurze',
    syncPendingChanges: 'Synchronizuj oczekujące zmiany',
    cloudLive: 'Synchronizacja z chmurą aktywna',
    deviceFallback: 'Tryb urządzenia',
    checkingCloud: 'Sprawdzanie chmury',
    addEvent: 'Dodaj wydarzenie',
    player: 'Zawodnik',
    playerOut: 'Zawodnik schodzi',
    playerIn: 'Zawodnik wchodzi',
    detail: 'Szczegóły',
    playerPerformance: 'Wydajność zawodników',
    liveRatings: 'Oceny na żywo',
    bench: 'Ławka',
    confirmSubstitution: 'Potwierdź zmianę',
    livePlayerCard: 'Karta zawodnika na żywo',
    startingXI: 'Pierwszy skład',
    playerNotesPlaceholder: 'Notatki o występie, instrukcje taktyczne, obserwacje indywidualne…',
    round: 'Kolejka',
    coachOverride: 'Mecz utworzony przez trenera',
    officialGdsfcFixture: 'Oficjalny mecz GDSFC',
    premiershipSchedule: 'Terminarz Premiership',
    leagueMatches: 'meczów ligowych',
    setKickoffBeforeSaving: 'Wczytano oficjalną datę meczu. Ustaw potwierdzoną godzinę rozpoczęcia przed zapisaniem.',
    kickoffRefereeSourceNote: 'GDSFC publikuje obecnie datę i rywala. Godzina, obiekt i sędzia pozostają TBA do oficjalnego potwierdzenia lub wpisania przez trenera.',
    backToDashboard: 'Powrót do panelu',
    matchdayGraphic: 'Grafika meczowa',
    lineupGraphic: 'Grafika składu',
    fullTimeGraphic: 'Grafika końcowego wyniku',
    fullTime: 'Koniec meczu',
    scorers: 'Strzelcy',
    assists: 'Asysty',
    playerOfTheMatch: 'Zawodnik meczu',
    onePlayerPerLine: 'Jeden zawodnik w każdym wierszu',
    toBeSelected: 'Do wyboru',

    matchdayGraphicSubtitle: 'Wygeneruj profesjonalną grafikę do udostępnienia z ogłoszonego składu i danych meczu.',
    socialFormat: 'Format społecznościowy',
    currentLineup: 'Aktualny skład',
    selectedPlayers: 'Wybrani zawodnicy',
    lineupNeedsEleven: 'Do oficjalnej grafiki pierwszego składu wybierz dokładnie 11 zawodników.',
    shareGraphic: 'Udostępnij grafikę',
    exportPng: 'Eksportuj PNG',
    generatingGraphic: 'Generowanie grafiki meczowej…',
    graphicReady: 'PNG gotowy.',
    sharedSuccessfully: 'Otwarto panel udostępniania.',
    noMatchAvailable: 'Brak nadchodzącego meczu dla grafiki.',
    substitutes: 'Rezerwowi',
    coachingStaff: 'Sztab szkoleniowy',
    headCoach: 'Pierwszy trener',
    assistantCoach: 'Asystent trenera',
    coach: 'Trener',
    addCoach: 'Dodaj trenera',
    coachRole: 'Rola',
    coachName: 'Imię i nazwisko trenera',
    teamPhoto: 'Zdjęcie drużyny',
    uploadTeamPhoto: 'Dodaj aktualne zdjęcie drużyny',
    teamPhotoHint: 'Zdjęcie jest optymalizowane na urządzeniu i dodawane do eksportowanej grafiki.',
    noBenchCandidates: 'Brak dodatkowych zawodników do wyboru.',
    optimizingPhoto: 'Optymalizacja zdjęcia…',
    photoReady: 'Zdjęcie gotowe do grafiki meczowej.',
    photoUploadFailed: 'Nie udało się przetworzyć zdjęcia.',
    photoStorageWarning: 'Zdjęcie jest zbyt duże dla lokalnej pamięci urządzenia. Eksport nadal działa w tej sesji.',
    tacticalBoardSubtitle: 'Buduj, przesuwaj i ogłaszaj pierwszy skład z jednego panelu taktycznego.',
    tacticalPresets: 'Ustawienia taktyczne',
    gamePlan: 'Plan gry',
    balancedPreset: 'Kontrola z balansem',
    balancedPresetDesc: 'Szerokość, posiadanie i stabilne zabezpieczenie.',
    highPressPreset: 'Wysoki pressing',
    highPressPresetDesc: 'Agresywna pierwsza linia i kompaktowa podwójna szóstka.',
    lowBlockPreset: 'Kompaktowy blok',
    lowBlockPresetDesc: 'Dwie linie po czterech i bezpośrednie wyjścia do kontry.',
    directPreset: 'Bezpośrednie przeciążenie',
    directPresetDesc: 'Trzech stoperów, wahadła i dwóch zawodników wspierających napastnika.',
    presetApplied: 'Zastosowano ustawienie taktyczne.',
    resetBoard: 'Wyczyść tablicę',
    availablePlayers: 'Dostępni zawodnicy',
    touchPlacementInstruction: 'Dotyk: wybierz zawodnika, potem pozycję na boisku. Komputer: przeciągnij i upuść.',
    leadership: 'Liderzy',
    captain: 'Kapitan',
    viceCaptain: 'Wicekapitan',
    announceLineup: 'Ogłoś skład',
    lineupAnnouncedStatus: 'Skład ogłoszony',
    lineupAnnounced: 'Pierwszy skład oznaczono jako ogłoszony.',
    lineupReturnedToDraft: 'Skład przywrócono do wersji roboczej.',
    announced: 'Ogłoszony',
    draft: 'Wersja robocza',
    savedLineupLoaded: 'Wczytano zapisany skład.',
    matchdayCommandCentre: 'Centrum dowodzenia meczem',
    matchdayReadiness: 'Gotowość meczowa',
    matchdayQuickAccess: 'Szybki dostęp meczowy',
    sundayGoLive: 'Tryb meczowy na niedzielę',
    matchdayControl: 'Centrum dnia meczowego',
    localDraftRecovered: 'Odzyskano lokalny szkic składu',
    lineupSavedCloudAndDevice: 'Skład zapisany w chmurze i zabezpieczony lokalnie',
    localDraftProtected: 'Lokalny szkic jest zabezpieczony',
    localBackupActive: 'Lokalna kopia aktywna',
    localBackupPreparing: 'Przygotowanie lokalnej kopii',
    localBackup: 'Lokalna kopia',

    matchSelected: 'Mecz wybrany',
    lineupAttached: 'Skład przypisany',

    matchdayCommandSubtitle: 'Połącz ogłoszony skład z meczem i zarządzaj całym dniem meczowym z jednego miejsca.',
    attachLineup: 'Przypisz skład',
    matchdayCommandSaved: 'Zapisano stan dnia meczowego.',
    matchdayStatus: 'Status dnia meczowego',
    planning: 'Planowanie',
    live: 'Na żywo',
    complete: 'Zakończony',
    attachedLineup: 'Przypisany skład',
    openTacticalBoard: 'Otwórz ustawienie taktyczne i wprowadź zmiany.',
    openLiveMatch: 'Otwórz zegar, wydarzenia i oceny zawodników na żywo.',
    mediaStudioBelow: 'Utwórz i udostępnij oficjalną grafikę meczową poniżej.',
    performanceReview: 'Analiza występu',
    performanceReviewSubtitle: 'Oceń występ meczowy, określ potrzeby rozwojowe zawodnika i przygotuj przyszłą kolejkę treningową.',
    matchRatings: 'Oceny meczowe',
    developmentProfile: 'Profil rozwoju',
    started: 'Pierwszy skład',
    technical: 'Techniczne',
    tactical: 'Taktyczne',
    physical: 'Fizyczne',
    developmentNeed: 'Potrzeba rozwojowa',
    flagWeakness: 'Oznacz słabość',
    weakness: 'Słabość',
    priority: 'Priorytet',
    developmentNotePlaceholder: 'Co wydarzyło się w meczu? Co należy poprawić?',
    saveDevelopmentNeed: 'Zapisz potrzebę rozwojową',
    developmentSignalSaved: 'Zapisano potrzebę rozwojową.',
    developmentPriorities: 'Priorytety rozwojowe',
    trainingQueue: 'Przyszła kolejka treningowa',
    noDevelopmentNeeds: 'Nie oznaczono jeszcze potrzeb rozwojowych dla tego zawodnika.',
    trainingModulePreview: 'Te priorytety zasilą osobny moduł Trening z ćwiczeniami indywidualnymi i zespołowymi.',
    noCompletedMatches: 'Brak zakończonych meczów do analizy.',
    trainingSubtitle: 'Zamień indywidualne i zespołowe słabości w praktyczne działania treningowe.',
    individualTraining: 'Indywidualny',
    teamTraining: 'Zespołowy',
    selectPlayer: 'Wybierz zawodnika',
    playerDevelopment: 'Rozwój zawodnika',
    trainingPlayerSheet: 'Karta treningowa zawodnika',
    manualTrainingTarget: 'Ręcznie wybrany cel treningowy',
    trainingMethod: 'Metoda treningowa',
    organisation: 'Organizacja',
    individualBlock: 'Blok indywidualny',
    teamApplication: 'Zastosowanie zespołowe',
    coachingPoints: 'Wskazówki trenerskie',
    progression: 'Progresja',
    workRest: 'Praca / odpoczynek',
    externalMethodReference: 'Otwórz zewnętrzną metodę / materiał',
    teamWeakness: 'Słabość zespołu',
    teamSession: 'Trening zespołu',
    setPieces: 'Stałe fragmenty',
    objective: 'Cel',
    sessionStructure: 'Struktura sesji',
    linkFirstTrainingNote: 'Wideo, zdjęcia i tablice pozostają zewnętrzne tam, gdzie to możliwe, aby aplikacja była lekka. Link otwiera oryginalny materiał szkoleniowy.',
    coachIntelligence: 'Inteligencja trenerska',
    coachIntelligenceSubtitle: 'Zamień potrzeby rozwojowe i termin meczu w praktyczne priorytety trenerskie.',
    priorityNeeds: 'Najważniejsze potrzeby',
    teamRecommendation: 'Rekomendacja zespołowa',
    smartTrainingCalendar: 'Inteligentny kalendarz treningowy',
    trainingWeek: 'Tydzień treningowy',
    smartPlannerNote: 'Plan tygodnia dostosowuje się do terminu następnego meczu i odsuwa najcięższe obciążenia piłkarskie od MD-1.',
    intelligenceMethod: 'Jak powstają rekomendacje',
    intelligenceMethodNote: 'Rekomendacje łączą potrzeby rozwojowe wskazane przez trenerów, rolę zawodnika i termin meczu. To wsparcie trenerskie, a nie zamiennik oceny sztabu medycznego lub przygotowania fizycznego.',
    sessionLibrary: 'Biblioteka treningów',
    sessionLibrarySubtitle: 'Zapisuj, oznaczaj jako ulubione i ponownie wykorzystuj treningi bez przechowywania ciężkich multimediów w aplikacji.',
    addSession: 'Dodaj trening',
    searchSessions: 'Szukaj treningów',
    sessionTitle: 'Nazwa treningu',
    optionalLink: 'Opcjonalny link zewnętrzny',
    saveSession: 'Zapisz trening',
    favourite: 'Ulubione',
    openReference: 'Otwórz materiał',
    internalSession: 'Trening wewnętrzny',
    developmentProgress: 'Postęp rozwoju',
    developmentProgressSubtitle: 'Śledź ten sam cel rozwojowy przez cały sezon zamiast opierać się na pojedynczych obserwacjach.',
    currentFocus: 'Aktualny cel',
    progress: 'Postęp',
    noProgressCheckpoints: 'Brak zapisanych punktów kontrolnych rozwoju.',
    developmentScore: 'Ocena rozwoju',
    progressNotePlaceholder: 'Co się poprawiło? Nad czym nadal trzeba pracować?',
    saveCheckpoint: 'Zapisz punkt kontrolny',








  },
} as const;
